/**
 * @description Link 類型 (enum)
 */
export enum LinkTypesEnum {
  /** 目錄 */
  Contents = '0',
  /** 文字 */
  Text = '1',
  /** 按鈕 */
  Button = '2',
  /** 展開文字 */
  Msg = '3',
  /** 文件 */
  Doc = '4'
}
